export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/asksumo.0818b95c.svg","height":40,"width":118,"blurWidth":0,"blurHeight":0};